module.exports = __webpack_public_path__ + "static/media/matilde-cap-brazil-sleepy.589645ff.png";